import { render } from "./SaveEmployee.vue?vue&type=template&id=304890b0&scoped=true"
import script from "./SaveEmployee.vue?vue&type=script&lang=js"
export * from "./SaveEmployee.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=304890b0&lang=scss&scoped=true"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304890b0"]])

export default __exports__